import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

const parseStoredToken = () => {
    const rawToken = localStorage.getItem("token");

    if (!rawToken) return null;

    try {
        const parsed = JSON.parse(rawToken);
        return typeof parsed === "string" ? parsed : rawToken;
    } catch (_error) {
        return rawToken;
    }
};

function connectToSocket() {
    const token = parseStoredToken();
    const backendUrl = getBackendUrl();

    return openSocket(getBackendUrl(), {
      // "flashsocket" e obsoleto e gera fallback desnecessario.
      transports: ["websocket", "polling"],
      timeout: 20000,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
      withCredentials: true,
      forceNew: true,
      auth: { token },
      query: { token },
      autoConnect: true
    });
}

export default connectToSocket;
